export default __webpack_public_path__ + "static/media/inpost-size-c.6bc33f9a.png";